import React from 'react';
import { FileText, Download, Mail } from 'lucide-react';
import { Button } from '../ui/button';

const ReceiptsList = ({ receipts, text, formatDate, formatAmount, onDownload, onResend }) => {
  if (receipts.length === 0) {
    return (
      <div className="text-center py-12">
        <FileText className="w-16 h-16 text-[#E2E8F0] mx-auto mb-4" />
        <p className="text-[#546A76]">{text.noReceipts}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {receipts.map((receipt) => (
        <div 
          key={receipt.id}
          data-testid={`receipt-item-${receipt.id}`}
          className="flex items-center justify-between p-4 rounded-xl border border-[#E2E8F0]"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-[#4A708B]/10 flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#4A708B]" />
            </div>
            <div>
              <p className="font-medium text-[#1A252C]">
                {receipt.receipt_number || `FEEP-${receipt.id.slice(0,8).toUpperCase()}`}
              </p>
              <p className="text-sm text-[#546A76]">
                {formatDate(receipt.created_at)} - {formatAmount(receipt.amount)}
              </p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              onClick={() => onDownload(receipt.id)}
              className="primary-btn rounded-full"
            >
              <Download className="w-4 h-4 mr-1" />
              {text.downloadReceipt}
            </Button>
            <Button
              size="sm"
              variant="outline"
              onClick={() => onResend(receipt.id)}
              className="rounded-full"
            >
              <Mail className="w-4 h-4" />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReceiptsList;
